import { ROLE_VALUES } from '@/config/constants';
import { getUserInfo } from '@/utils/userInfo';

/** システム管理者、または救急科管理者（manager） */
export function canAccessBudgetAdjustment(): boolean {
  const user = getUserInfo();
  if (!user) return false;
  return user.role === ROLE_VALUES.SYSTEM || user.role === ROLE_VALUES.MANAGER;
}
